import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import mediaSearchActions from 'redux/actions/mediaSearchActions'

function MediaSearchFactory(WrappedComponent) {
	class MediaSearch extends PureComponent {

		constructor() {
			super()
			this.onMediaSearchConfirm = this.onMediaSearchConfirm.bind(this)
			this.onMediaSearchChange = this.onMediaSearchChange.bind(this)
			this.onMediaSearchNextPageRequest = this.onMediaSearchNextPageRequest.bind(this)
			this.onMediaSearchSelection = this.onMediaSearchSelection.bind(this)
			this.onMediaSearchClear = this.onMediaSearchClear.bind(this)

			this.defaultState = {
				results: [],
				active: false,
				value: '',
				page: 1,
				selected: [],
				showMore: false,
				message: '',
				title: '',
				hint: '',
			}

			this.state = {
				image: {...this.defaultState},
				gif: {...this.defaultState},
				video: {...this.defaultState},
			}
		}

		_search(mediaType, mediaSource, value = this.state[mediaType].value, page = this.state[mediaType].page) {
			return new Promise((resolve, reject) => {
				this.props.actions.search({
					value,
					page,
					searchType: mediaType,
					allowSearchMore: true,
					source: mediaSource,
				}, resolve, reject)
			})
		}

		onMediaSearchConfirm(mediaType, mediaSource, searchValue = '') {
			let value = searchValue || this.state[mediaType].value
			value = value.trim()
			if ( value !== '') {
				this.setState({
					[mediaType]: {
						...this.defaultState,
						active: true,
						value,
					},
				})
				this._search(mediaType, mediaSource, value, 1)
					.then(response => {
						this.setState({
							[mediaType]: {
								...this.state[mediaType],
								results: response.payload.data,
								page: this.state[mediaType].page+1,
								showMore: response.payload.showMore && this.state[mediaType].page !== 1,
								message: response.message,
								hint: response.payload.hint,
							},
						})
						if (response.payload.data.length > 0 && mediaSource !== 'youtube') {
							this.onMediaSearchNextPageRequest(mediaType, mediaSource)
						}
					})
					.catch(error => {
						let title
						if (error.message.indexOf('blocked') !== -1) {
							title = 'This Content is blocked'
						} else {
							title = 'We\'re Sorry!'
						}
						this.setState({
							[mediaType]: {
								...this.state[mediaType],
								message: error.message,
								title,
							},
						})
					})
			}
		}

		onMediaSearchChange(event, mediaType) {
			this.setState({
				[mediaType]: {
					...this.state[mediaType],
					value: event.target.value,
				},
			})
		}

		onMediaCSEResults = results => {
			this.setState({
				['image']: {
					...this.state['image'],
					selected: [],
					results,
				},
			})
		}

		onMediaSearchNextPageRequest(mediaType, mediaSource) {
			this._search(mediaType, mediaSource).then(response => {
				this.setState({
					[mediaType]: {
						...this.state[mediaType],
						results: [...this.state[mediaType].results, ...response.payload.data],
						page: this.state[mediaType].page+1,
						showMore: response.payload.showMore,
					},
				})
			}).catch(() => {
				// console.log(error)
			})
		}

		onMediaSearchSelection(fileIndex, mediaType) {
			let newSelectedArray, indexInSelectedArray
			if (this.props.multiselect) {
				if (this.state[mediaType].selected.includes(fileIndex)) {
					newSelectedArray = [...this.state[mediaType].selected]
					indexInSelectedArray = this.state[mediaType].selected.indexOf(fileIndex)
					newSelectedArray.splice(indexInSelectedArray, 1)
					this.setState({
						[mediaType]: {
							...this.state[mediaType],
							selected: newSelectedArray,
						},
					})
				} else {
					newSelectedArray = [...this.state[mediaType].selected]
					newSelectedArray.push(fileIndex)
					this.setState({
						[mediaType]: {
							...this.state[mediaType],
							selected: newSelectedArray,
						},
					})
				}
			} else {
				this.setState({
					[mediaType]: {
						...this.state[mediaType],
						selected: [fileIndex],
					},
				})
			}
		}

		onMediaSearchClear(mediaType) {
			this.setState({
				[mediaType]: {...this.defaultState},
			})
		}

		render() {
			return (<WrappedComponent
				onMediaSearchConfirm = {this.onMediaSearchConfirm}
				onMediaSearchChange = {this.onMediaSearchChange}
				onMediaSearchNextPageRequest = {this.onMediaSearchNextPageRequest}
				onMediaCSEResults = {this.onMediaCSEResults}
				onMediaSearchSelection = {this.onMediaSearchSelection}
				onMediaSearchClear = {this.onMediaSearchClear}
				imageSearchTextValue = {this.state.image.value}
				imageSearchResults = {this.state.image.results}
				imageSearchActive = {this.state.image.active}
				imageSearchSelected = {this.state.image.selected}
				imageShowMore = {this.state.image.showMore}
				imageMessage = {this.state.image.message}
				imageTitle = {this.state.image.title}
				imageHint = {this.state.image.hint}
				gifSearchTextValue = {this.state.gif.value}
				gifSearchResults = {this.state.gif.results}
				gifSearchActive = {this.state.gif.active}
				gifSearchSelected = {this.state.gif.selected}
				gifShowMore = {this.state.gif.showMore}
				gifMessage = {this.state.gif.message}
				gifTitle = {this.state.gif.title}
				gifHint = {this.state.gif.hint}
				videoSearchTextValue = {this.state.video.value}
				videoSearchResults = {this.state.video.results}
				videoSearchActive = {this.state.video.active}
				videoSearchSelected = {this.state.video.selected}
				videoShowMore = {this.state.video.showMore}
				videoMessage = {this.state.video.message}
				videoTitle = {this.state.video.title}
				videoHint = {this.state.video.hint}
				{...this.props} />
			)
		}

	}

	function mapDispatchToProps(dispatch) {
		return bindActionsToDispatch({
			search: mediaSearchActions.search,
		}, dispatch)
	}

	return connect(null, mapDispatchToProps)(MediaSearch)
}

export default MediaSearchFactory
